import type { SVGProps } from "react";
export interface TagDollarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TagDollarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TagDollarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.877 4.22c0-.606-.491-1.097-1.097-1.097h-6.4a2.2 2.2 0 0 0-1.4.5l-.163.147-8.043 8.044a2.21 2.21 0 0 0 0 3.124l5.286 5.288.169.151a2.21 2.21 0 0 0 2.956-.15l8.045-8.046a2.2 2.2 0 0 0 .646-1.561v-6.4Zm2.25 6.4c0 1.182-.47 2.316-1.305 3.152l-8.045 8.045a4.46 4.46 0 0 1-6.14.158l-.166-.158-5.287-5.288a4.46 4.46 0 0 1 0-6.306l8.043-8.044.329-.297A4.46 4.46 0 0 1 13.38.872h6.399a3.347 3.347 0 0 1 3.347 3.348z"
      />
      <path
        fill={color}
        d="M10.38 9.451c.853-.789 2.008-.804 2.957-.362a1.124 1.124 0 0 1 1.58 1.56c.418.88.348 1.822-.01 2.539a1.124 1.124 0 1 1-2.012-1.006.63.63 0 0 0 .054-.362c-.018-.129-.083-.302-.275-.494a.9.9 0 0 0-.536-.275c-.147-.013-.216.032-.243.06l-.005.001.002.002a.2.2 0 0 0-.032.04l-.003.004-.002.004-.001.013q-.002.02.006.07c.025.164.136.431.392.815l.127.205c.622 1.053.946 2.585-.196 3.728-.87.871-2.127 1.022-3.171.566a1.124 1.124 0 0 1-1.585-1.553 2.9 2.9 0 0 1 .01-2.537l.057-.101a1.126 1.126 0 0 1 1.954 1.108l-.029.075a.64.64 0 0 0-.025.286c.019.129.083.303.276.495.32.32.726.265.92.07.069-.067.11-.148.1-.307a1.4 1.4 0 0 0-.174-.554l-.136-.231c-.319-.478-.641-1.071-.743-1.714-.112-.713.056-1.466.665-2.075zm7.995-2.45a1.375 1.375 0 0 1-2.742.14l-.007-.14.007-.141A1.375 1.375 0 0 1 17 5.625l.14.007c.694.07 1.235.656 1.235 1.368Z"
      />
    </svg>
  );
}
